import React, { ReactNode } from 'react'
import clsx from 'clsx'
import { Loader } from '../Loader/Loader'
import { Button, ButtonProps } from '../Button/Button'
import { SVGIcon } from '../SVGIcon/SVGIcon'
import { SVGIconConditionalProps } from '../SVGIcon/types/SVGIcon.types'
import { ButtonLinkProps } from '../ButtonLink/ButtonLink'
import styles from './styles/IconButton.module.scss'

type IconButtonProps = ButtonProps & {
  iconProps?: SVGIconConditionalProps
  iconPosition?: 'left' | 'right'
}

export const IconButton: React.FC<IconButtonProps> = props => {
  const { iconProps, iconPosition = 'left', children, className, ...rest } = props

  return (
    <Button className={clsx(styles.iconButton, iconPosition && styles[iconPosition], className)} {...rest}>
      {iconProps?.name && <SVGIcon {...iconProps} />}
      {children}
    </Button>
  )
}

type IconButtonLinkProps = ButtonLinkProps & {
  preLink?: ReactNode
  preLinkClassName?: string
  iconProps?: SVGIconConditionalProps
  iconPosition?: IconButtonProps['iconPosition']
  svgLinkColor?: boolean
  linkTextClassName?: string
}

export const IconButtonLink: React.FC<IconButtonLinkProps> = props => {
  const {
    iconProps,
    iconPosition = 'left',
    preLink,
    preLinkClassName,
    children,
    className,
    isLoading,
    disabled,
    onClick,
    underline,
    svgLinkColor,
    linkTextClassName,
    ...rest
  } = props

  return (
    <button
      disabled={disabled || isLoading}
      onClick={onClick}
      type="button"
      data-render-variant="icon"
      className={clsx(
        styles.iconButton,
        svgLinkColor && styles.svgLinkColor,
        disabled && styles.svgDisabled,
        className
      )}
      {...rest}
    >
      {isLoading && <Loader variant="dark" />}
      <div className={clsx(styles.iconAndLink, styles[iconPosition])}>
        {iconProps?.name && <SVGIcon {...iconProps} />}
        {(children || preLink) && (
          <span className={styles.linkContainer}>
            {preLink && <span className={clsx(styles.preLink, preLinkClassName)}>{preLink}</span>}
            <span
              className={clsx(
                styles.link,
                styles.linkText,
                (disabled || isLoading) && styles.linkDisabled,
                underline && !disabled && !isLoading && styles.underline,
                linkTextClassName
              )}
            >
              {children}
            </span>
          </span>
        )}
      </div>
    </button>
  )
}
